import { render } from "./AuditLogs.vue?vue&type=template&id=88c50424&scoped=true"
import script from "./AuditLogs.vue?vue&type=script&lang=js"
export * from "./AuditLogs.vue?vue&type=script&lang=js"

import "./AuditLogs.vue?vue&type=style&index=0&id=88c50424&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c50424"]])

export default __exports__